const EVENT = 'tinycms-profile-photo';

function key(userId: string) {
  return `tinycms.profilePhoto.${userId}`;
}

export function loadProfilePhoto(userId?: string | null) {
  if (!userId) return '';
  try {
    return localStorage.getItem(key(userId)) || '';
  } catch {
    return '';
  }
}

export function saveProfilePhoto(userId: string, url: string) {
  localStorage.setItem(key(userId), url);
  window.dispatchEvent(new CustomEvent(EVENT, { detail: { userId, url } }));
}

export function watchProfilePhoto(onChange: () => void) {
  window.addEventListener(EVENT, onChange);
  return () => window.removeEventListener(EVENT, onChange);
}

const IMAGE_TYPES = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp'];

export async function uploadProfilePhoto(file: File): Promise<string> {
  if (!IMAGE_TYPES.includes(file.type)) {
    throw new Error('Choose a JPEG, PNG, GIF, or WebP image.');
  }
  const backendHost = process.env.REACT_APP_BACKEND_HOST || 'http://localhost:4000';
  const body = new FormData();
  body.append('file', file);
  const token = localStorage.getItem('token');
  const response = await fetch(`${backendHost}/api/upload/media`, {
    method: 'POST',
    headers: token ? { Authorization: `Bearer ${token}` } : undefined,
    body,
  });
  const result = (await response.json().catch(() => ({}))) as { url?: string; error?: string };
  if (!response.ok || !result.url) {
    throw new Error(result.error || 'Could not save that photo.');
  }
  return result.url;
}
